// extracted by css-extract-rspack-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1_5FU","cls2":"UserTaggingPingBodyStyles-cls2_lQY UserTaggingPingBodyStyles-cls1_5FU"};